module.exports = __webpack_public_path__ + "img/Vector28.653b2cf7.svg";